@if (immersiveViewService.canUseImmersiveView()) {
    <div class="relative h-full w-full overflow-hidden rounded-xl">
        @switch (immersiveViewService.currentImmersiveView()) {
            @case (ImmersiveCurrentViewEnum.PANORAMAX) {
                @defer (when immersiveViewUiService.isPanelOpened()) {
                    <app-panoramax class="absolute inset-0 block overflow-hidden" />
                }
            }

            @case (ImmersiveCurrentViewEnum.GOOGLE_STREET_VIEW) {
                @defer (when immersiveViewUiService.isPanelOpened()) {
                    <app-google-street-view class="absolute inset-0 block overflow-hidden" />
                }
            }
        }

        <app-immersive-view-overlay class="pointer-events-none absolute inset-0 z-30 block" />
    </div>
}
